import React, { useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import WhyChooseUs from "./components/WhyChooseUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Products from "./components/Products";
import WhatsAppWidget from "./components/WhatsAppWidget";
import Mission from "./components/Mission";
import CustomSourcing from "./components/CustomSourcing";

export default function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [, setProduct] = useState("Select a product");

  const scrollTo = (id) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-background text-slate-900 overflow-x-hidden selection:bg-accent selection:text-primary">
      <Navbar
        scrollTo={scrollTo}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
      />
      <main>
        <Hero scrollTo={scrollTo} />
        <About scrollTo={scrollTo} />
        <Mission />
        <Products scrollTo={scrollTo} />
        <CustomSourcing />
        <WhyChooseUs />
        <Contact setProduct={setProduct} />
      </main>
      <Footer scrollTo={scrollTo} />
      <WhatsAppWidget />
    </div>
  );
}
